import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import {
    HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { UserService } from '../services/user.service';
import { Utilities } from '../shared/utils';
import { ToastService } from '../services/toast.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class TokenExpiryInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private userService: UserService,
        private toast: ToastService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (isPlatformBrowser(this.platformId)) {
            const token = localStorage.getItem('authToken');
            const currentUrl = this.router.url;
            if (token && Utilities.isTokenExpired(token) && !this.isAuthRoute(currentUrl)) {
                this.handleSessionExpiry();
                return EMPTY;
            }
        }

        return next.handle(req).pipe(
            catchError((err: HttpErrorResponse) => {
                if (err.status === 401 && !this.isAuthRoute(this.router.url)) {
                    this.handleSessionExpiry();
                    return EMPTY;
                }
                return throwError(() => err);
            })
        );
    }

    private handleSessionExpiry(): void {
        this.userService.signout();
        this.toast.info("Your session has expired. Please log in again.");
        this.router.navigate(['/login']);
    }

    private isAuthRoute(url: string): boolean {
        return url.startsWith('/login') || url.startsWith('/register');
    }
}
